import { HttpClient } from '../http/http-client';
import type { CreateCall, Call, LeadCtx, SignUpGuest, GuestProfile, AgentCtx, LoginForm, LoginWithTokenForm } from './protocol';

export class SpinnerApi {

  constructor(
    private httpClient: HttpClient,
    ) {
  }

  public async getGuestProfile(): Promise<GuestProfile> {
      return this.httpClient.get('users/guest/profile');
  }

  public async signUpGuest(body: SignUpGuest): Promise<LeadCtx> {
    return this.httpClient.post('users/guest', body);
  }

  /**
   * @param body CreateCall
   */
  public async createCall(body: CreateCall): Promise<Call> {
    return this.httpClient.post('calls/create', body);
  }
  
  // Agent API
  public async login(body: LoginForm | LoginWithTokenForm): Promise<AgentCtx> {
    return this.httpClient.post('session', body);
  }

  public async getSession(): Promise<AgentCtx> {
    return this.httpClient.get('session');
  }
}
